import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { ValidationService } from '../../common/services';
import { ButtonAction, ButtonType } from '../action-button/constants';
import { ActionButtonComponent } from '../action-button/action-button.component';
import { mustNotBeBlankValidator } from '../../common/utils';
import { ExportFileFacade } from '../../common/models';
import { UntypedFormBuilder, UntypedFormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { ExportType } from '../../store';
import { IconNames } from '../../common/constants/icon-names';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';

@Component({
  imports: [
    ActionButtonComponent,
    CommonModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    MatInputModule,
    TranslateModule,
    MatOptionModule,
    MatSelectModule,
    SvgIconComponent,
  ],
  templateUrl: './export-dialog.component.html',
  styleUrls: ['./export-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExportDialogComponent implements OnInit {
  exportDialogForm: UntypedFormGroup;
  buttonAction = ButtonAction;
  buttonType = ButtonType;
  navigationNeeded = false;
  reportTypeOptions = [ExportType.TrackAndTrace, ExportType.DeliveryPerformance];
  iconNames = IconNames;

  constructor(
    public validationService: ValidationService,
    public dialogRef: MatDialogRef<ExportDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      isReportLimitationExceeded: boolean;
      reportLimitRows: number;
      facade: ExportFileFacade;
      addressExport?: string;
      hasReportType?: boolean;
    },
    private fb: UntypedFormBuilder,
  ) {}

  ngOnInit(): void {
    this.initForm();
  }

  confirm(navigationNeeded: boolean): void {
    const { reportName, reportType } = this.exportDialogForm.value;
    const clearReportName = reportName.trim();
    if (this.data.addressExport) {
      return this.data.facade.startExportToFile(
        clearReportName,
        this.dialogRef,
        navigationNeeded,
        this.data.addressExport,
        reportType,
      );
    }
    return this.data.facade.startExportToFile(clearReportName, this.dialogRef, navigationNeeded, null, reportType);
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  get hasReportType(): boolean {
    return this.data.hasReportType;
  }

  private initForm(): void {
    if (this.hasReportType) {
      this.exportDialogForm = this.fb.group({
        reportName: ['', [Validators.required, mustNotBeBlankValidator]],
        reportType: [ExportType.TrackAndTrace, [Validators.required]],
      });
    } else {
      this.exportDialogForm = this.fb.group({
        reportName: ['', [Validators.required, mustNotBeBlankValidator]],
      });
    }
  }
}
